// extracted by mini-css-extract-plugin
export var lg = "_10-4";
export var md = "_10-3";
export var sm = "_10-2";
export var xs = "_10-1";
export var xxs = "_10-0";